import { RECIPE_NAME_HIBISCUS } from '../../../../constants/recipes';
import { hasAnyRecipe } from '../../foundation/hooks/use-recipe';

export function isCuratedHeroSupported(patch) {
  return hasAnyRecipe(patch, [RECIPE_NAME_HIBISCUS]);
}
